import { render, staticRenderFns } from "./modalCriarTabelaPreco.vue?vue&type=template&id=bc9da312&scoped=true"
import script from "./modalCriarTabelaPreco.vue?vue&type=script&lang=ts"
export * from "./modalCriarTabelaPreco.vue?vue&type=script&lang=ts"
import style0 from "./modalCriarTabelaPreco.vue?vue&type=style&index=0&id=bc9da312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9da312",
  null
  
)

export default component.exports